import { Injectable } from '@angular/core';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import {
  DataService,
  ObjectKey,
  PersistenceService,
  PersistMode,
  PersistObjectModel,
  TargetColumnValue,
  TargetObjectData,
} from '@barthauer/abc/core/data';
import { Observable } from 'rxjs';
import { ObjectKeys } from '../../../services/data.service';
import { CommentModel } from '@barthauer/abc/common-editors';

@Injectable({
  providedIn: 'root',
})
export class CommentsService {
  private deleteCommentUri: string;
  private commentUri: string;
  constructor(
    private coreDataService: DataService,
    private configService: AbcConfigService,
    private persistenceService: PersistenceService
  ) {}

  public persistComment(comment: CommentModel, measureId: string): Observable<any> {
    const commentColumns: TargetColumnValue[] = [
      { Name: 'Text', Value: comment.Text }
    ];
    const commentPersistQuery: TargetObjectData = new TargetObjectData();
    commentPersistQuery.ObjectKey = new ObjectKey();
    commentPersistQuery.ObjectKey.ObjectType = ObjectKeys.COMMENT;
    commentPersistQuery.TargetColumns = commentColumns;
    const persistObject: PersistObjectModel = new PersistObjectModel();
    persistObject.Object = commentPersistQuery;
    if (comment.Id) {
      commentPersistQuery.Mode = PersistMode.Update;
      commentPersistQuery.ObjectKey.Id = comment.Id;
    } else {
      commentPersistQuery.Mode = PersistMode.Insert;
      commentColumns.push(
        { Name: 'ParentId', Value: measureId },
        { Name: 'ParentObjectType', Value: ObjectKeys.MEASURE }
      );
    }
    return this.coreDataService.executePersistObjectQuery(persistObject);
  }

  public persistDeleteComment(id: string): Observable<any> {
    const persistQuery: PersistObjectModel = new PersistObjectModel();
    const targetObject: TargetObjectData = new TargetObjectData();
    targetObject.Mode = PersistMode.Delete;
    targetObject.ObjectKey = new ObjectKey();
    targetObject.ObjectKey.Id = id;
    targetObject.ObjectKey.ObjectType = ObjectKeys.COMMENT;
    persistQuery.Object = targetObject;
    return this.persistenceService.executePersistObjectQuery(persistQuery);
  }
}
